/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetTypeOneResponseDto
 */
export interface AssetTypeOneResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetTypeOneResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeOneResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeOneResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeOneResponseDto
     */
    description?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssetTypeOneResponseDto
     */
    metadataSchema?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeOneResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeOneResponseDto
     */
    updatedAt: Date;
    /**
     * Array of subsystem IDs associated with this asset type
     * @type {Array<string>}
     * @memberof AssetTypeOneResponseDto
     */
    subsystems?: Array<string>;
}

/**
 * Check if a given object implements the AssetTypeOneResponseDto interface.
 */
export function instanceOfAssetTypeOneResponseDto(value: object): value is AssetTypeOneResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function AssetTypeOneResponseDtoFromJSON(json: any): AssetTypeOneResponseDto {
    return AssetTypeOneResponseDtoFromJSONTyped(json, false);
}

export function AssetTypeOneResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetTypeOneResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'metadataSchema': json['metadataSchema'] == null ? undefined : json['metadataSchema'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'subsystems': json['subsystems'] == null ? undefined : json['subsystems'],
    };
}

export function AssetTypeOneResponseDtoToJSON(json: any): AssetTypeOneResponseDto {
    return AssetTypeOneResponseDtoToJSONTyped(json, false);
}

export function AssetTypeOneResponseDtoToJSONTyped(value?: AssetTypeOneResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'metadataSchema': value['metadataSchema'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'subsystems': value['subsystems'],
    };
}

